import { DataDownloadMessages } from '../types';

export const dataDownloadJA: DataDownloadMessages = {
  'app.datadownload.checkbox.study_abroad': 'プログラム',
  'app.datadownload.checkbox.additional_demographics_info': 'オプション/追加の背景情報',
  'app.datadownload.checkbox.remove_anonymous_user': '匿名受検者の除外',
}

